
















import Vue from 'vue';
import NOC from '@/class/common/const';
import TermsFooter from './TermsFooter.vue';

export default Vue.extend({
  name: 'Personal',
  components: { TermsFooter },
  props: {
    isPhone: Boolean,
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  data() {
    return {
      show: false,
    };
  },
});
